import { Component } from "vue-property-decorator";
import { FormModule } from "@/store/modules/form";
import { UserModule } from "@/store/modules/user";
import { envRootLocalizedDomain } from "@/utils";
import { auth } from "@/utils/auth-service";
import { persistanceService } from "@/utils/persistance-service";
import { mixins } from "vue-class-component";
import LangControls from "@/mixins/LangControls.mixin";
import FooterLinks from "@/mixins/FooterLinks.mixin";
import { reactProxyFactory } from "@/components/shared/ReactProxy.component";
import {
  Signup as ReactSignup,
  ISignupProps,
} from "@graphapi-io/customer-components";
import { FunctionComponent } from "react";

const Signup = reactProxyFactory<FunctionComponent<ISignupProps>, ISignupProps>(
  ReactSignup as FunctionComponent<ISignupProps>,
);

@Component({})
export default class SignupView extends mixins(LangControls, FooterLinks) {
  initialEmail = "";
  optInConfirmed = "";
  state = null;
  form = false;

  get auth() {
    return auth;
  }

  get isStatusValid(): boolean {
    return this.optInConfirmed === "accepted";
  }

  get privacyUrl(): string {
    return `${envRootLocalizedDomain()}/privacy`;
  }

  get termsUrl(): string {
    return `${envRootLocalizedDomain()}/terms`;
  }

  created() {
    this.initialEmail = (this.$route.query.email as string) ?? "";
  }

  async onSignup(credentials: {
    username: string;
    password: string;
  }): Promise<void> {
    const result =
      await this.$authManager.userDataLoader.auth.signUp(credentials);
    UserModule.handleSignupResponse({ credentials, result });
    FormModule.handleValidCredentials(credentials);
    persistanceService.setCredentials(credentials);
    this.$router.push({ name: "signup-code-entry" });
  }

  private onLoginClick() {
    this.$router.push({ name: "login" });
  }

  private get copies() {
    return {
      signUp: {
        login: this.$t("signup.login").toString(),
        quote: this.$t("signup.quote").toString(),
        quoteAuthor: this.$t("signup.quoteAuthor").toString(),
        title: this.$t("signup.title").toString(),
        subtitle: this.$t("signup.subtitle").toString(),
        signUp: this.$t("signup.signUp").toString(),
        emailLabel: this.$t("signup.emailLabel").toString(),
        emailPlaceholder: this.$t("signup.emailPlaceholder").toString(),
        passwordLabel: this.$t("signup.passwordLabel").toString(),
        passwordPlaceholder: this.$t("signup.passwordPlaceholder").toString(),
        choosePasswordPlaceholder: this.$t(
          "signup.choosePasswordPlaceholder",
        ).toString(),
        errorEmailRequired: this.$t("signup.errorEmailRequired").toString(),
        errorPasswordRequired: this.$t(
          "signup.errorPasswordRequired",
        ).toString(),
        errorPasswordMinLength: this.$t(
          "signup.errorPasswordMinLength",
        ).toString(),
      },
      authFooter: {
        imprintLink: this.$t("global_imprint").toString(),
        termsOfServiceLink: this.$t("global_terms").toString(),
        privacyPolicyLink: this.$t("global_privacy_policy").toString(),
      },
    };
  }

  render() {
    return (
      <Signup
        componentProps={{
          copies: this.copies,
          imprintUrl: this.imprintUrl,
          termsOfServiceUrl: this.termsUrl,
          privacyPolicyUrl: this.privacyUrl,
          onLangChange: this.onLangChange,
          currentLang: this.currentLang,
          langOptions: this.langOptions,
          onSignup: this.onSignup,
          onLoginClick: this.onLoginClick,
        }}
      />
    );
  }
}
